<template>
  <div>
    <div class='textInstructions' v-html='$t("text.page5_instructions")'></div>
    <div style='padding-left:20px;padding-right:20px;'>
      
      <div class='form-row'>
        <div class='col-11 col-sm-auto textSectionTitle' v-html="$t('text.page5_content1_header')"></div>
        <div class='col-1 col-sm-auto'>
          <button class="moreHelp" @click="openTooltip($t('text.page5_tooltip'))" :aria-label="$t('text.moreinformation') + $t('text.page5_content1_header')">
            <img src='../assets/images/helpIcon.png' style='margin-top:1px;' alt=""/>
          </button>
        </div>
        <div class='col'></div>
        <div class='col-12' v-html='$t("text.page5_content1")'>
        </div>
      </div>
      <div class='form-row'>
        <fieldset role="group" class='form-group' style='margin-top:0px;'>
            <legend id='lbl_mq1' class='radioLegend' style='font-weight: 600; color: #333;'>{{$t("text.page5_input1")}}</legend>
            <div class='col' style='padding-top:15px;padding-left:00px;padding-right:0px;'>
                <span class='radio'>
                    <input v-model="confirmEligibility" name='confirmEligibility' id='mq1y' type='radio' value='true' checked='checked' aria-labelledby='lbl_confirmEligibility_yes'/>
                    <label id='lbl_confirmEligibility_yes' for='mq1y' class='radio-label'>{{$t('text.yes')}}</label>
                </span>
                <span class='radio'>
                    <input v-model="confirmEligibility" name='confirmEligibility' id='mq1n' type='radio' value='false' aria-labelledby='lbl_confirmEligibility_no'/>
                    <label id='lbl_confirmEligibility_no' for='mq1n' class='radio-label'>{{$t('text.no')}}</label>
                </span>
            </div>
            <span for='mq1y' class='feedback' id='err_confirmEligibility' tabindex="-1"></span>
        </fieldset>
        <div id='not_eligible_warning' style='display:none;'>
          <div class='invalid-feedback'>
            <span v-if='this.$store.state.site==="cibc"' v-html="$t('text.page5_error')"></span>
            <span v-else v-html="$t('text.page5_errornm')"></span><br/><br/>
            <button v-if='this.$store.state.site==="cibc"' @click='newTCTIQuote()' id='getTripCanQuote' class='btn btn-primary' style='width:100%; height: auto; white-space: normal;'>{{$t('text.page5_error2')}}</button>
            <button v-else id='getTripCanQuote' @click='newTCTIQuote()' class='btn btn-primary' style='width:100%; height: auto; white-space: normal;'>{{$t('text.page5_error2nm')}}</button>
            <br/><br/>
            <span v-if='this.$store.state.site==="cibc"'>{{$t('text.page5_error3')}}</span>
            <span v-else>{{$t('text.page5_error3nm')}}</span>
            <br/><br/>
            <span>{{$t('text.page5_error4')}}</span>
            <br/><br/>
            <button @click='newQuote()' id='restartApplication' class='btn btn-primary' style='width:100%; height: auto; white-space: normal;'>{{$t('text.page5_error5')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addNavProceedCheck } from "../utils/navProceed.js";
import { initKeywords } from "../utils/keywords.js";
import { validationRules } from "../utils/validation_rules.js";
import { validateForm, validateField } from "../utils/validation.js";
import { getSurveyQuestions } from "../utils/getSurveyQuestions.js";
import bus from "../utils/bus.js";

export default {
  computed: {
    confirmEligibility: {
      get() {
        return this.$store.state.confirmEligibility;
      },
      set() {
        validateField(mq1y, true, validationRules());
      }
    }
  },
  methods:{
    newTCTIQuote() {
      this.$store.state.wantsMedical=false;
      this.$store.state.wantsCancellation=true;
      this.$router.push("/TravelPlans");
    },
    newQuote() {
        let pathInsert="";
        const pathArray=window.location.pathname.split("/");
        if(pathArray[1]==="cibc"||pathArray[2]==="cibc") { pathInsert="/cibc";}
        else if(pathArray[1]==="cibcinsurance"||pathArray[2]==="cibcinsurance"){ pathInsert="/cibcinsurance";}
        window.location.href=window.location.origin + pathInsert;
    },
    openTooltip(text) {
      document.getElementById("keywordBody").innerHTML=text;
      this.$nextTick(()=>{
        document.getElementById("keywordBody").focus();
      });
      bus.$emit("openModal");
    }
  },
  mounted() {
    getSurveyQuestions();
    // If this session already has a policy number, reset the session
    if(this.$store.state.policyNumber!==""){location.reload();}

    // Focus stepTitle for accessibility.
    this.$nextTick( () => {
      document.getElementById("stepTitle").focus();
    });

    initKeywords(this);

    // Check if Next button should be enabled or disabled.
    const targets = [
      document.getElementById("mq1y")
    ];
    this.$nextTick( () => {
      addNavProceedCheck(targets);
    });
  },
};

</script>
<style>
.helpspanText {
  margin-left: 15px;
  margin-top:5px;
  color: #0F5A7B;
}
.textQuestion {
  color:#333333;
  font-weight: 600;
}
</style>